// ---------------------------------------------------------------------------
// PWA_ControlBillet — useHeartbeat hook
// Starts heartbeat + offline background sync on mount, stops on unmount.
// ---------------------------------------------------------------------------

import { useEffect } from 'react'
import { heartbeatService } from '@/services/heartbeat'
import { offlineQueue } from '@/services/offline-queue'

/**
 * Mount-level hook that keeps the heartbeat and offline sync running
 * for the lifetime of the component that uses it (typically the root layout).
 */
export function useHeartbeat(): void {
  useEffect(() => {
    heartbeatService.start()
    offlineQueue.startBackgroundSync()

    return () => {
      heartbeatService.stop()
      offlineQueue.stopBackgroundSync()
    }
  }, [])
}
